<template>
  <div class="wrapper">
    <div class="grid">
      <router-link
        :to="
          $i18nRoute({
            name: 'NewsDetail',
            params: { slug: item.url }
          })
        "
        class="grid__item"
        v-for="(item, index) in list"
        :key="index"
      >
        <div class="card">
          <div class="card__img-wrapper">
            <span class="card__category">{{ item.sub_category.name }}</span>
            <div class="card__img">
              <ImageContainer
                class="img"
                :src="item.image.medium"
                :thumb="item.image.thumbnail"
                :alt="item.title"
              />
            </div>
          </div>
          <div class="card__content">
            <h4 class="card__title limited-text">{{ item.title }}</h4>
            <div class="data-news">
              <span class="day">{{ handleDate(item.pub_date) }},</span>
              <span class="time">{{ handleTime(item.pub_date) }}</span>
            </div>
          </div>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
import ImageContainer from "@/components/ImageContainer";
import { useFormatter } from "@/utils/formatter";

export default {
  name: "FirstBar",
  components: {
    ImageContainer
  },
  props: {
    list: {
      type: Array,
      required: true
    }
  },
  setup() {
    return {
      ...useFormatter()
    };
  }
};
</script>

<style lang="scss" scoped>
$green: #447562;
$category: rgba(255, 255, 255, 0.7);

.wrapper {
  width: 90%;
  padding: 6rem 0 3rem;
  margin: 0 auto;
  @media screen and (max-width: 767px) {
    padding: 2rem 0;
  }
}
.grid {
  // min-width: 100%;
  display: grid;

  // gap: 0.5rem;
  display: grid;
  width: 100%;
  // max-width: var(--main-wrapper-width);
  grid-template-columns: repeat(4, 1fr);
  grid-template-areas:
    "item-1 item-2 item-3 item-3"
    "item-4 item-5 item-6 item-7";
  @media screen and (max-width: 992px) {
    grid-template-columns: repeat(3, 1fr);
    grid-template-areas:
      "item-1 item-1 item-1 "
      "item-2 item-3 item-4 "
      "item-5 item-6 item-7";
  }
  @media screen and (max-width: 767px) {
    grid-template-columns: 1fr;
    grid-template-areas:
      "item-1"
      "item-2"
      "item-3"
      "item-4"
      "item-5"
      "item-6"
      "item-7";
  }
  &__item:nth-child(1) {
    grid-area: item-1;
    padding-left: 3rem;
    @media screen and (max-width: 992px) {
      padding-left: 0;
      margin-bottom: 2rem;
      width: 100%;
      transform: translateY(-38px);
    }
    @media screen and (max-width: 767px) {
      transform: translateY(0);
    }
    .card {
      @media screen and (max-width: 767px) {
        display: flex;
        &__title {
          margin-top: 0;
        }
        &__content {
          display: flex;
          flex-direction: column;
          justify-content: center;
          margin-left: 0.5rem;
        }
      }
      &__img {
        @media screen and (max-width: 992px) {
          height: 531px;
          min-width: 100%;
        }
        @media screen and (max-width: 767px) {
          height: 138px;
          min-width: auto;
          width: 183px;
        }
        @media screen and (max-width: 375px) {
          // flex: 1 0 20%;
          // height: auto;
        }
      }
    }
  }
  &__item:nth-child(2) {
    grid-area: item-2;
    padding-left: 3rem;

    .card {
      @media screen and (max-width: 767px) {
        display: flex;
        &__title {
          margin-top: 0;
        }
        &__content {
          display: flex;
          flex-direction: column;
          justify-content: center;
          margin-left: 0.5rem;
        }
      }
      &__img {
        @media screen and (max-width: 767px) {
          height: 138px;
          min-width: auto;
          width: 183px;
        }
      }
    }
    @media screen and (max-width: 992px) {
      padding: 0 2.5rem 0 0;
    }
    @media screen and (max-width: 767px) {
      padding: 0;
    }
  }
  &__item:nth-child(3) {
    padding-left: 3rem;
    grid-area: item-3;
    position: relative;
    @media screen and (max-width: 992px) {
      padding: 0 1.25rem;
      transform: translateY(-20px);
    }
    @media screen and (max-width: 767px) {
      transform: translateY(0);
      padding: 0;
    }
    .card {
      position: absolute;
      width: 90%;
      top: -350px;
      left: 50%;
      transform: translateX(-44%);
      @media screen and (max-width: 992px) {
        position: relative;
        top: 0;
        width: auto;
        transform: translateX(0%);
        left: 0;
      }
      @media screen and (max-width: 767px) {
        display: flex;
        padding: 2rem 0rem 0.6rem 2rem;
        border-bottom: 1px solid #fff;
      }

      &__img {
        max-width: 100%;
        // height: 409vw;
        height: 545px;
        @media screen and (max-width: 1400px) {
        height: 480px;
        
        }
        .img {
          padding-bottom: 0%;
        }
        @media screen and (max-width: 992px) {
          height: 125px;
        }
        @media screen and (max-width: 767px) {
          display: none;
        }
      }
      &__img-wrapper {
        max-width: 100%;
      }
      &__content {
        @media screen and (max-width: 767px) {
          margin-top: 1rem;
        }
      }
      &__title {
        @media screen and (max-width: 767px) {
          font-family: Roboto;
          font-style: normal;
          font-size: 14px;
          line-height: 18px;
        }
      }
    }
  }
  &__item:nth-child(4) {
    grid-area: item-4;
    padding: 0 1rem;
    margin-top: 2rem;
    @media screen and (max-width: 992px) {
      margin-top: 0rem;
      padding: 0 0 0 2.5rem;
      transform: translateY(-60px);
    }
    @media screen and (max-width: 767px) {
      transform: translateY(0);
      padding: 0;
    }
    .card {
      @media screen and (max-width: 767px) {
        display: flex;
        padding: 2rem 2rem 0.6rem;
        border-bottom: 1px solid #fff;
      }
      &__img {
        @media screen and (max-width: 767px) {
          display: none;
        }
      }
      &__content {
        @media screen and (max-width: 767px) {
          margin-top: 1rem;
        }
      }
      &__title {
        @media screen and (max-width: 767px) {
          font-family: Roboto;
          font-style: normal;
          font-size: 14px;
          line-height: 18px;
        }
      }
    }
  }
  &__item:nth-child(5) {
    grid-area: item-5;
    padding: 0 1rem;
    margin-top: 2rem;
    @media screen and (max-width: 992px) {
      padding: 0 2.5rem 0 0;
    }
    @media screen and (max-width: 767px) {
      transform: translateY(0);
      padding: 0;
      margin: 0;
    }
    .card {
      @media screen and (max-width: 767px) {
        display: flex;
        padding: 2rem 2rem 0.6rem;
        border-bottom: 1px solid #fff;
      }
      &__img {
        @media screen and (max-width: 767px) {
          display: none;
        }
      }
      &__content {
        @media screen and (max-width: 767px) {
          margin-top: 1rem;
        }
      }
      &__title {
        @media screen and (max-width: 767px) {
          font-family: Roboto;
          font-style: normal;
          font-size: 14px;
          line-height: 18px;
        }
      }
    }
  }
  &__item:nth-child(6) {
    grid-area: item-6;
    padding: 0 1rem;
    margin-top: 2rem;
    @media screen and (max-width: 992px) {
      padding: 0 1.25rem;
      transform: translateY(-20px);
    }
    @media screen and (max-width: 767px) {
      transform: translateY(0);
      padding: 0;
    }
    .card {
      @media screen and (max-width: 767px) {
        display: flex;
        &__title {
          margin-top: 0;
        }
        &__content {
          display: flex;
          flex-direction: column;
          justify-content: center;
          margin-left: 0.5rem;
        }
      }
      &__img {
        @media screen and (max-width: 767px) {
          height: 133px;
          min-width: auto;
          width: 183px;
        }
      }
    }
  }
  &__item:nth-child(7) {
    grid-area: item-7;
    padding: 0 1rem;
    margin-top: 2rem;
    @media screen and (max-width: 992px) {
      padding: 0 0 0 2.5rem;
      transform: translateY(-60px);
    }
    @media screen and (max-width: 767px) {
      transform: translateY(0);
      padding: 0;
    }
    .card {
      @media screen and (max-width: 767px) {
        display: flex;
        &__title {
          margin-top: 0;
        }
        &__content {
          display: flex;
          flex-direction: column;
          justify-content: center;
          margin-left: 0.5rem;
        }
      }
      &__img {
        @media screen and (max-width: 767px) {
          height: 138px;
          min-width: auto;
          width: 183px;
        }
      }
    }
  }
}
.card {
  &__img-wrapper {
    position: relative;
  }
  &__category {
    position: absolute;
    left: -1px;
    top: 0;
    z-index: 1;
    background-color: $green;
    color: $category;
    padding: 1px 5px;
    @media screen and (max-width: 992px) {
      text-transform: uppercase;
    }
    @media screen and (max-width: 767px) {
      font-family: Open Sans;
      font-style: normal;
      font-weight: 600;
      font-size: 10px;
      line-height: 14px;
      /* identical to box height */

      color: rgba(255, 255, 255, 0.6) ;
    }
  }
  &__img {
    // max-width: 390px;
    // height: 293px;
    .img {
      padding-bottom: 66%;
    }
    @media screen and (max-width: 992px) {
      height: 125px;
      .img {
        padding-bottom: 0%;
      }
    }
  }
  &__content {
    text-align: center;
    width: 100%;
    @media screen and (max-width: 992px) {
      text-align: left;
    }
  }
  &__title {
    font-family: "Roboto";
    font-weight: 500;
    font-size: 1.2em;
    line-height: 130%;
    margin-top: 0.2em;
    color: #ffffff;
    --snup: 4;
    @media screen and (max-width: 992px) {
      font-size: 16px;
      line-height: 22px;
    }
    @media screen and (max-width: 767px) {
      font-size: 12px;
      line-height: 15px;
    }
  }
  .data-news {
    font-family: "Open Sans";
      font-size: 0.88em;

    line-height: 19px;
    margin-top: 0.5rem;
    color: #ffffff;
    @media screen and (max-width: 992px) {
      font-size: 13px;
    }
    @media screen and (max-width: 767px) {
      font-size: 10px;
      color: var(--color-category);
    }
  }
}
</style>
